import {
  ConversationMessage,
  ConversationsPerDay,
  ConversationsPerWeek,
  FeedbackSummary,
  NegativeFeedbackList,
  UsersPerDay,
  WeeklyActiveUsers,
} from '../../types/analyticsTypes'
import { axiosClient } from '../axiosClient'

export const analyticsFunctions = {
  fetchFeedbackSummary: async (): Promise<FeedbackSummary> => {
    return await axiosClient.get('api/analytics/feedback-summary')
  },

  fetchWeeklyActiveUsers: async (): Promise<WeeklyActiveUsers[]> => {
    return await axiosClient.get('api/analytics/weekly-active-users')
  },

  fetchConversationsPerDay: async (): Promise<ConversationsPerDay[]> => {
    return await axiosClient.get('api/analytics/conversations-per-day')
  },

  fetchConversationsPerWeek: async (): Promise<ConversationsPerWeek[]> => {
    return await axiosClient.get('api/analytics/conversations-per-week')
  },

  fetchUsersPerDay: async (): Promise<UsersPerDay[]> => {
    return await axiosClient.get('api/analytics/users-per-day')
  },

  fetchNegativeFeedback: async (
    limit: number,
    offset: number,
    days: number,
  ): Promise<NegativeFeedbackList> => {
    return await axiosClient.get(
      `api/analytics/negative-feedback?limit=${limit}&offset=${offset}&days=${days}`,
    )
  },

  fetchNegativeFeedbackConversation: async (
    messageId: string,
  ): Promise<ConversationMessage[]> => {
    return await axiosClient.get(
      `api/analytics/negative-feedback/${messageId}/conversation`,
    )
  },
}
